export enum SeriesType {
  TEMPERATURE = 1,
  PERCENT = 2,
  RPM = 3,
  ROR = 4,
  CRACK = 5,
  PRESSURE = 6,
  TOTAL_CRACKS = 7,
  WEIGHT = 8,
}
